<template>
  <div class="bg-[#000060]">
    <section class="xl:program-screen-minus-header-xl relative w-full">
      <div
        class="block aspect-square size-full animate-pulse bg-gray-300 object-cover lg:aspect-video"
        alt="Image"
      />

      <div
        class="absolute bottom-0 z-30 flex w-full justify-between bg-[#D9D9D9]/60 px-4 py-2 text-lg font-bold uppercase text-white shadow-[10px_-10px_10px_-10px_rgba(0,0,0,0.2)] backdrop-blur-md dark:bg-[#082792]/30 sm:px-6 sm:py-2.5 lg:py-3 lg:text-xl xl:px-20 2xl:text-2xl"
      >
        <div class="flex w-full items-center">
          <div class="mr-2 flex items-center gap-3 lg:gap-6">
            <div
              class="flex h-fit items-center justify-center rounded-full bg-white/30 px-5 py-1 shadow-sm"
            >
              <p class="text-sm font-black text-transparent lg:text-base 2xl:text-2xl">180</p>
            </div>
            <div
              class="flex h-fit items-center justify-center rounded-full bg-white/30 px-5 py-1 shadow-sm"
            >
              <p class="text-sm font-black text-transparent lg:text-base 2xl:text-2xl">2D</p>
            </div>
          </div>
          <div class="hidden w-full justify-center gap-6 md:flex">
            <div
              class="relative flex w-full max-w-36 items-center rounded-full bg-white/30 px-2 py-1 lg:max-w-52 2xl:max-w-60"
            >
              <div class="size-6 lg:size-8 2xl:size-10" />
              <span class="mx-auto text-transparent">PLAY</span>
            </div>
            <div
              class="relative flex w-full max-w-36 items-center rounded-full bg-white/30 px-2 py-1 lg:max-w-52 2xl:max-w-60"
            >
              <div class="size-6 lg:size-8 2xl:size-10" />
              <span class="mx-auto text-transparent">PREVIEW</span>
            </div>
          </div>
        </div>
        <div class="flex w-fit items-center gap-4">
          <div
            class="hidden w-fit items-center gap-1 rounded-full bg-white/30 px-6 py-2 text-transparent xl:flex"
          >
            <div class="size-8" />
            BACK
          </div>
        </div>
      </div>
    </section>
    <section class="prose max-w-none bg-white p-5 dark:prose-invert lg:prose-xl dark:bg-inherit">
      <p class="max-h-96 overflow-y-scroll" />
      <div class="flex w-full justify-center gap-4 md:hidden">
        <div
          class="flex w-full max-w-36 animate-pulse rounded-full bg-black/10 px-2 py-1 dark:bg-white/30"
        >
          <div class="size-6" />
          <span class="mx-auto text-transparent">PLAY</span>
        </div>
        <div
          class="flex w-full max-w-36 animate-pulse rounded-full bg-black/10 px-2 py-1 dark:bg-white/30"
        >
          <div class="size-6" />
          <span class="mx-auto text-transparent">PREVIEW</span>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.gradient-wrapper {
  @apply p-1 rounded-full;
  background: linear-gradient(90deg, #2fecf6 2.09%, #4425fe 34.06%, #8214de 63.53%, #e980a1 97.49%);
}

.program-button {
  @apply px-6 py-2 text-black dark:text-white bg-white dark:bg-black  rounded-full flex gap-x-1 items-center w-full;

  & svg {
    fill: linear-gradient(
      90deg,
      #2fecf6 2.09%,
      #4425fe 34.06%,
      #8214de 63.53%,
      #e980a1 97.49%
    ) !important;
  }
}
</style>
